function initializeModalAndAccordion() {
  const modal = document.getElementById('size-guide');

  if (!modal || modal.dataset.sizeGuideInitialized === 'true') {
    return;
  }

  modal.dataset.sizeGuideInitialized = 'true';

  const announcer = document.getElementById('sizeGuideAnnouncer');
  const closeButton = modal.querySelector('[data-size-guide-close]');
  const openButtons = document.querySelectorAll('[data-size-guide-open]');
  const sizeGuideTypeSelect = document.getElementById('sizeGuideType');
  const unitButtons = document.querySelectorAll('.unit-toggle');
  let opener = null;

  function updateTable() {
    if (!sizeGuideTypeSelect) {
      return;
    }

    const selectedType = sizeGuideTypeSelect.value;
    const selectedUnitButton = document.querySelector('.unit-toggle.btn-selected');
    if (!selectedUnitButton) {
      return;
    }

    const selectedUnit = selectedUnitButton.dataset.unit;
    const allTables = document.querySelectorAll('.size-guide-content');

    allTables.forEach((content) => {
      content.style.display = 'none';
    });

    const tableId = `size-guide-${selectedType}`;
    const selectedTableContent = document.getElementById(tableId);

    if (selectedTableContent) {
      selectedTableContent.style.display = 'block';
      const unitTables = selectedTableContent.querySelectorAll('table');
      unitTables.forEach((table) => {
        table.style.display = 'none';
      });

      const unitTable = selectedTableContent.querySelectorAll(`[data-table="${selectedType}-${selectedUnit}"]`);
      unitTable.forEach((table) => {
        table.style.display = 'table';
      });
    }
  }

  function announceModalOpened() {
    const message = modal.dataset.sizeGuideOpenedMessage;
    if (!announcer || !message) {
      return;
    }

    announcer.textContent = '';
    window.requestAnimationFrame(() => {
      announcer.textContent = message;
    });
  }

  function isOpen() {
    return modal.classList.contains('show') && !modal.hasAttribute('hidden');
  }

  function setExpanded(expanded) {
    openButtons.forEach((button) => {
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function openModal(trigger) {
    opener = trigger || document.activeElement;
    updateTable();
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('show');
    modal.style.display = 'block';
    document.body.classList.add('modal-open');
    document.body.style.overflow = 'hidden';
    setExpanded(true);
    announceModalOpened();

    if (typeof trapFocus === 'function') {
      trapFocus(modal, modal);
    } else {
      modal.focus();
    }
  }

  function closeModal() {
    if (!isOpen()) {
      return;
    }

    modal.classList.remove('show');
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('hidden', '');
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    setExpanded(false);

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(opener);
    } else if (opener) {
      opener.focus();
    }

    opener = null;

    if (announcer) {
      announcer.textContent = '';
    }
  }

  function toggleModal(trigger) {
    if (isOpen()) {
      closeModal();
    } else {
      openModal(trigger);
    }
  }

  openButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      toggleModal(button);
    });
  });

  if (closeButton) {
    closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      closeModal();
    });
  }

  modal.addEventListener('click', (event) => {
    if (event.target === modal) {
      closeModal();
    }
  });

  modal.addEventListener('keydown', (event) => {
    if (event.code.toUpperCase() === 'ESCAPE') {
      closeModal();
    }
  });

  if (sizeGuideTypeSelect && unitButtons.length > 0) {
    sizeGuideTypeSelect.addEventListener('change', updateTable);

    unitButtons.forEach((button) => {
      button.addEventListener('click', function () {
        unitButtons.forEach((btn) => btn.classList.remove('btn-selected'));
        this.classList.add('btn-selected');
        updateTable();
      });
    });

    unitButtons[0].classList.add('btn-selected');
    updateTable();
  }

  const accordionHeaders = document.querySelectorAll('.card-header__title');
  if (accordionHeaders.length > 0) {
    accordionHeaders.forEach((header) => {
      header.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = header.getAttribute('href').substring(1);
        const content = document.getElementById(targetId);
        const toggleSymbol = header.querySelector('.accordion-toggle-symbol');

        const isCollapsed = content.classList.contains('show');
        if (isCollapsed) {
          content.classList.remove('show');
          header.setAttribute('aria-expanded', 'false');
          header.classList.add('collapsed');
          toggleSymbol.textContent = '+';
        } else {
          document.querySelectorAll('.collapse.show').forEach((collapse) => {
            collapse.classList.remove('show');
            collapse.previousElementSibling.querySelector('.card-header__title').setAttribute('aria-expanded', 'false');
            collapse.previousElementSibling.querySelector('.card-header__title').classList.add('collapsed');
            collapse.previousElementSibling.querySelector('.accordion-toggle-symbol').textContent = '+';
          });

          content.classList.add('show');
          header.setAttribute('aria-expanded', 'true');
          header.classList.remove('collapsed');
          toggleSymbol.textContent = '−';
        }
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', initializeModalAndAccordion);
document.addEventListener('section:load', initializeModalAndAccordion);
